import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import { FooterComponent } from "../../components/common/footer/footer";
import { NavigationComponent } from "../../components/common/navigation/navigation";
import { AuthService } from "../../services/authservice";

@Component({
  selector: "page-forbidden",
  templateUrl: "forbidden.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FooterComponent, NavigationComponent, TranslatePipe],
})
export class ForbiddenPage {
  protected auth = inject(AuthService);
}
